import React from "react"

interface FloatingBadgeProps {
	children: React.ReactNode
	className?: string
}

const FloatingBadge: React.FC<FloatingBadgeProps> = ({
	children,
	className = "",
}) => {
	return (
		<div className={`absolute z-30 top-1 right-1 px-1 py-1 rounded-full flex items-center ${className}`}>
			{children}
		</div>
	)
}

export default FloatingBadge
